<template>
      <div>
          
        <b-icon icon="files" variant="success" animation="throb" font-scale="8" />
        <hr>
        <h3 class="mb-0">  {{$t('general.sure')}} </h3>
        <p> 
            {{hours[data.begin_day_id - 1].name}} gününe ait mesai saati diğer günlere kopyalanmak üzere, 
            Eğer daha önceden girilmiş bir mesai saati var ise değiştirilecektir ve bu işlem geri alınamaz.
        </p>
        <ul style="text-align: left">
            <li><strong>{{$t('account.workHours.beginDay')}} :</strong> {{hours[data.begin_day_id - 1].name}}</li>
            <li><strong>{{$t('account.workHours.endDay')}} :</strong> {{hours[data.end_day_id - 1].name}}</li>
            <li><strong>{{$t('account.workHours.openingTime')}} :</strong> {{data.opening_time}}</li>
            <li><strong>{{$t('account.workHours.closingTime')}} :</strong> {{data.is_close}}</li>
            <li><strong>{{$t('account.workHours.offDay')}} :</strong> {{data.is_close ? 'Tatil Günü' : 'İş Günü'}}</li>
            <li><strong>{{$t('account.workHours.earlyEntryTol')}} :</strong> {{data.early_dis_tol}}</li>
            <li><strong>{{$t('account.workHours.lateEntryTol')}} :</strong> {{data.tardy_dis_tol}}</li>
            <li><strong>{{$t('account.workHours.earlyClosingTol')}} :</strong> {{data.early_arm_tol}}</li>
            <li><strong>{{$t('account.workHours.lateClosingTol')}} :</strong> {{data.tardy_arm_tol}}</li>
            <li><strong>{{$t('account.workHours.outOfHoursTol')}} :</strong> {{data.non_over_time}}</li>
        </ul>
   </div>
</template>

<script>
       import i18n from '@/plugins/i18n';

    let  hours = [
        {key:1, name: i18n.t('general.days.mon') },
        {key:2, name: i18n.t('general.days.tue') },
        {key:3, name: i18n.t('general.days.wed') },
        {key:4, name: i18n.t('general.days.thu') },
        {key:5, name: i18n.t('general.days.fri') },
        {key:6, name: i18n.t('general.days.sat') },
        {key:7, name: i18n.t('general.days.sun')},
    ];
    export default {
        name: "AccountDelete",
        data:function(){
            return{
                hours
            }
        },
        props:{
            data: Object,
            modalName: String,
            modalEvent: Function,
            save: Boolean,
            saveState: Function,
            formName: String
        },
        watch:{
            save: async function(data){
                if(data){
                    let params = {
                        accountId: this.$store.getters.accountId ? this.$store.getters.accountId.data : parseInt(this.$route.params.id),
                        id: this.data && this.data.id
                    }
                     await this.$store.dispatch('copyWorkHour', params)
                     if(this.$store.getters.getAccountStatus.status == "Success"){
                        await this.$store.dispatch('getAccountHours', {accountId: this.$store.getters.accountId ? this.$store.getters.accountId.data : this.$route.params.id })
                        await this.$store.dispatch('getAccountDetail', {id: this.$store.getters.accountId ? this.$store.getters.accountId.data : this.$route.params.id })
                    }
                }
                this.saveState(false)
                this.modalEvent(false)
            },
        }
    }
</script>
<style  scoped>
ul{
    text-align: left;
    list-style: none;
}
</style>


// WEBPACK FOOTER //
// src/pages/Alarmsis/Account/modals/WorkHoursCopy.vue